module.exports = __webpack_public_path__ + "img/PTM.0b35fa64.jpg";